import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({ selector: '[portalClickDelay]', standalone: true })
export class ClickDelayDirective implements OnInit, OnDestroy {
  private readonly clicks = new Subject<MouseEvent>();
  @Output() readonly delayedClick = new EventEmitter<MouseEvent>();

  private _delayTime = 500;

  get delayTime(): number {
    return this._delayTime;
  }

  @Input() set delayTime(value: number) {
    this._delayTime = value;
  }

  ngOnInit(): void {
    this.clicks.pipe(debounceTime(this._delayTime)).subscribe(event => this.delayedClick.emit(event));
  }

  ngOnDestroy(): void {
    this.clicks.unsubscribe();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault(); // Prevents multiple quick executions
    this.clicks.next(event);
  }
}
